import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import Item from "@/models/WebsiteWidget/Accordion/Item/Item";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class Accordion extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/accordion';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetAccordions';

    static model_name = 'Accordion';

    static fields() {
		return {
			id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
            items: this.hasMany(Item, 'website_widget_accordion_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Items() {
        return this.getRelated('items');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
